import Benchmark from './Benchmark';
import './Benchmark.scss';

export default Benchmark;